import '../stylesheets/main.scss';

import 'what-input';
import htmx from 'htmx.org';
import Alpine from '@alpinejs/csp';

// @ts-ignore
import intersect from '@alpinejs/intersect';
// @ts-ignore
import focus from '@alpinejs/focus';
// @ts-ignore
import collapse from '@alpinejs/collapse';

import 'photoswipe/style.css';
import '@glidejs/glide/dist/css/glide.core.min.css';

import Components from './components';

// Alpine.js directives
// See https://alpinejs.dev/advanced/extending#custom-directives
import ResizeObserverDirective from './directives/resizeobserver';

// htmx initialization
// See https://htmx.org/docs/#webpack
window.htmx = htmx;

window.Alpine = Alpine;

Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(focus);

Alpine.directive('resizeobserver', ResizeObserverDirective);

Alpine.data('Accordion', Components.Accordion);
Alpine.data('AccordionItem', Components.AccordionItem);
Alpine.data('ActionBar', Components.ActionBar);
Alpine.data('AnimatedLogo', Components.AnimatedLogo);
Alpine.data('Animation', Components.Animation as any);
Alpine.data('ArticleStage', Components.ArticleStage);
Alpine.data('AuthorStage', Components.AuthorStage);
Alpine.data('Button', Components.Button);
Alpine.data('Christmascard', Components.Christmascard as any);
Alpine.data('ContactForm', Components.ContactForm as any);
Alpine.data('ContentBlocks', Components.ContentBlocks);
Alpine.data('Dialog', Components.Dialog);
Alpine.data('DownloadForm', Components.DownloadForm as any);
Alpine.data('EventTeaser', Components.EventTeaser as any);
Alpine.data('Footer', Components.Footer);
Alpine.data('Form', Components.Form);
Alpine.data('Gallery', Components.Gallery);
Alpine.data('Header', Components.Header);
Alpine.data('HeroTeaser', Components.HeroTeaser);
Alpine.data('InfoCards', Components.InfoCards);
Alpine.data('InlineTeaser', Components.InlineTeaser);
Alpine.data('MainStage', Components.MainStage as any);
Alpine.data('Marquee', Components.Marquee);
Alpine.data('Navigation', Components.Navigation);
Alpine.data('PhotoWall', Components.PhotoWall as any);
Alpine.data('Quote', Components.Quote);
Alpine.data('ScrollContainer', Components.ScrollContainer);
Alpine.data('ScrollInfo', Components.ScrollInfo);
Alpine.data('Search', Components.Search as any);
Alpine.data('SearchDialog', Components.SearchDialog as any);
Alpine.data('Section', Components.Section);
Alpine.data('Stage', Components.Stage);
Alpine.data('StandardTeaser', Components.StandardTeaser);
Alpine.data('SuccessStoryStage', Components.SuccessStoryStage as any);
Alpine.data('SuccessStoryTeaser', Components.SuccessStoryTeaser as any);
Alpine.data('TeaserGrid', Components.TeaserGrid as any);
Alpine.data('TeaserSlider', Components.TeaserSlider as any);
Alpine.data('Tooltip', Components.Tooltip as any);
Alpine.data('Video', Components.Video);
Alpine.data('VideoStage', Components.VideoStage);

// Heroes Campaign
Alpine.data('HeroesTopicStage', Components.HeroesTopicStage);
Alpine.data('HeroesComicItem', Components.HeroesComicItem);

Alpine.store('general', {
  isSearchOpen: false,
  // Navigation
  isNavOpen: false,
  isSubNavOpen: false,
  openSubNavIndex: undefined,

  openSearch() {
    this.isSearchOpen = true;
  },
  closeSearch() {
    this.isSearchOpen = false;
  },
  openNav() {
    this.isNavOpen = true;
  },
  openSubNav(index = 0) {
    this.openSubNavIndex = index;
    this.isNavOpen = true;
    this.isSubNavOpen = true;
  },
  closeNav() {
    this.isNavOpen = false;
    this.isSubNavOpen = false;
    this.openSubNavIndex = undefined;
  },
  closeSubNav() {
    this.isSubNavOpen = false;
    this.openSubNavIndex = undefined;
  }
} as any);

Alpine.start();

const galleries = document.querySelectorAll('[data-pswp-gallery]');
if (galleries) {
  const { default: PhotoSwipeLightbox } = await import('photoswipe/lightbox');

  const lightbox = new PhotoSwipeLightbox({
    gallery: '[data-pswp-gallery]',
    showHideAnimationType: 'fade',
    children: 'a[data-pswp]',
    pswpModule: () => import('photoswipe')
  });

  lightbox.init();
}

// All links with target="_blank" attribute should have an attribute rel="noopener". This has performance and security reasons https://developers.google.com/web/tools/lighthouse/audits/noopener
document.querySelectorAll("[target='_blank']").forEach((link) => {
  link.setAttribute('rel', 'noopener');
});

document.querySelectorAll("img[alt]").forEach((element) => {
  const image = element as HTMLImageElement;
  if (image.alt === "") image.setAttribute('role', 'presentation');
});
